<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <!-- <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração</mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="100" formControlName="Geracao"
                                    [readonly]="readyOnlyGeracao" [class.InputBlockColor]="readyOnlyGeracao">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readyOnlyGeracao"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readyOnlyGeracao"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}
                                </mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração</mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="10" readonly
                                    formControlName="Geracao" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espécie</mat-label>
                                <input matInput id="txtEspecie" #txtEspecie maxlength="10" readonly
                                    formControlName="Especie" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Especie)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->

                    <div class="row pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10" readonly
                                    formControlName="Tp_colheita" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTipoColheita.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tp_colheita)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade(%)</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="3" readonly
                                    formControlName="Umidade" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="5" formControlName="Umidade"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" (blur)="makeFxAzulUmidadeCalc()">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <!-- <i matSuffix class="{{iconEnableField}}" *ngIf="!readyOnlyUmidade"></i> -->
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Colheita</mat-label>
                                <input matInput id="txtDataColheita" #txtDataColheita maxlength="20"
                                    formControlName="Dt_colheita" mask="d0/M0/0000" type="text"
                                    (blur)="calcHarvestWeek()" (blur)="alertaData()" class="InputLabelDetailsColor">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataColheita.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Dt_colheita)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término enchimento Data</mat-label>
                                <input matInput id="txtTermEnchimentoData" #txtTermEnchimentoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Termino_enchimento_data"
                                    (blur)="makeCalculations()" (blur)="calcHarvestWeek()" (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtTermEnchimentoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término enchimento Hora</mat-label>
                                <input matInput id="txtTermEnchimentoHora" #txtTermEnchimentoHora maxlength="5"
                                    mask="Hh:m0" formControlName="Termino_enchimento_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtTermEnchimentoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Saída Campo Data</mat-label>
                                <input matInput id="txtSaidaCampoData" #txtSaidaCampoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Saida_campo_data" (blur)="makeCalculations()"
                                    (blur)="calcHarvestWeek()" (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtSaidaCampoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Saida_campo_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Saída Campo Hora</mat-label>
                                <input matInput id="txtSaidaCampoHora" #txtSaidaCampoHora maxlength="5" mask="Hh:m0"
                                    formControlName="Saida_campo_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtSaidaCampoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Saida_campo_hora)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de Espera Campo {{hintHourResult}}</mat-label>
                                <input matInput id="txtTempoEsperaCampo" #txtTempoEsperaCampo maxlength="5" readonly
                                    formControlName="Tempo_espera_campo" currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTempoEsperaCampo.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_espera_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Respónsavel Liberação Colheita</mat-label>
                                <input matInput id="txtRespLibColheita" #txtRespLibColheita maxlength="30"
                                    formControlName="Resp_liberacao_colheita">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtRespLibColheita.value.length}} / 30</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Resp_liberacao_colheita)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>